// extracted by mini-css-extract-plugin
module.exports = {"control":"e2ff468f85--control--RswFG"};